import {inject, Injectable} from '@angular/core';
import {UploadExcelApiService} from "./upload-excel-api.service";
import {SelectWbAccountData, UploadExcelParams} from "../types/upload-excel-modal.types";
import {FileParams} from "../../../../types/file.types";
import {HttpEventType} from "@angular/common/http";
import {defaultFileParams} from "../../../../models/default-file-params";
import {UploadProgressService} from "../../../../services/upload-progress.service";
import {ErrorService} from "../../../../services/error.service";
import {ProgressStatus} from "../../../../types/upload-progress.types";

@Injectable({
  providedIn: 'root'
})
export class UploadExcelService {
  private uploadExcelApiService: UploadExcelApiService = inject(UploadExcelApiService);
  private uploadProgressService: UploadProgressService = inject(UploadProgressService);
  private errorService: ErrorService = inject(ErrorService);

  public getSelectDataWbAccounts(path: string): Promise<Array<SelectWbAccountData>> {
    return new Promise<Array<SelectWbAccountData>>((resolve, reject) => {
      this.uploadExcelApiService.getSelectDataWbAccounts(path).subscribe({
        next: (wbAccounts) => resolve(wbAccounts),
        error: (err) => reject(err)
      });
    });
  }

  public async uploadExcel(uploadExcelParams: UploadExcelParams): Promise<FileParams> {
    return new Promise((resolve, reject) => {
      this.uploadExcelApiService.uploadExcel(uploadExcelParams).subscribe({
        next: (event) => {
          const progress = this.handleUploadEvent(event);
          this.uploadProgressService.updateProgress({
            progress: progress.progress,
            completed: progress.completed,
            fileName: uploadExcelParams.fileName,
            fileType: 'file',
          });

          if (event.type === HttpEventType.Response) {
            setTimeout(() => {
              const fileParams = event.body;
              resolve(fileParams || defaultFileParams);
              this.uploadProgressService.resetProgress();
            }, 300);
          }
        },
        error: (error) => {
          this.errorService.handleError(error);
          this.uploadProgressService.resetProgress();
          reject(error);
        }
      });
    });
  }

  private handleUploadEvent(event: any): ProgressStatus {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        const progress = Math.round(100 * event.loaded / (event.total || 1));
        return { progress, completed: false };
      case HttpEventType.Response:
        return { progress: 100, completed: true };
      default:
        return { progress: 0, completed: false };
    }
  }
}
